import { BUFFERED_REQUEST_STORAGE_PREFIX } from '@shared/extension/constants';
import { captureSentryMessage } from '@shared/sentry';
import { postToBackend } from './post-to-backend';

export function attachCopilotInjectionScript(): void {
  const copilotScript = document.createElement('script');
  copilotScript.src = chrome.runtime.getURL('copilot-injection-script.js');
  copilotScript.onload = function () {
    // @ts-ignore
    this.remove();
    loadAndSendBufferedRequests();
  };
  (document.head || document.documentElement).appendChild(copilotScript);
  console.log('Attached "copilot-injection-script" to the content page');
}

function loadAndSendBufferedRequests(): void {
  const bufferedRequests = new Map<string, string>();
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key?.startsWith(BUFFERED_REQUEST_STORAGE_PREFIX)) {
      const value = localStorage.getItem(key);
      if (value) {
        bufferedRequests.set(key, value);
      }
    }
  }

  if (bufferedRequests.size > 0) {
    captureSentryMessage(`Found ${bufferedRequests.size} buffered requests to send`);
    bufferedRequests.forEach((value, key) => {
      postToBackend(JSON.parse(value));
      localStorage.removeItem(key);
    });
  }
}
